import { render } from "./ManagerJoinBadge.vue?vue&type=template&id=05fe24a3&scoped=true"
import script from "./ManagerJoinBadge.vue?vue&type=script&lang=js"
export * from "./ManagerJoinBadge.vue?vue&type=script&lang=js"

import "./ManagerJoinBadge.vue?vue&type=style&index=0&id=05fe24a3&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fe24a3"]])

export default __exports__